import * as React from "react";
import { makeStyles, Text } from "@fluentui/react-components";
import { CardSection } from "../../components/CardSection";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
        padding: "2rem",
        width: "80%",
        margin: "0 auto",
        maxWidth: "1400px"
    }
});

export const Id = "abedd72c-c4ff-4a43-a2d7-16591a4f5222";
export const Title = "Does Ianus send information of my publisher to external systems?";
export const Subtitle = "Explanation on data and external systems";
export const Description = "Find out whether Ianus sends data from your system to external systems";
export const Keywords = ["telemetry", "data", "external", "system"];

export const Component: React.FC = React.memo(() => {
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <CardSection title="Fundamentals">
                <Text>
                    Ianus is designed to work securely and privately within your own Dataverse environment.
                    Below is a breakdown of how data is handled.
                </Text>
            </CardSection>

            <CardSection title="No Communication Required">
                <Text>
                    Ianus does <strong>not</strong> require communication with the Ianus SaaS platform for license validation.
                    All validation is performed locally using metadata and logic embedded into your Dataverse solution.
                </Text>
            </CardSection>

            <CardSection title="Client Behavior">
                <Text>
                    The Ianus clients installed on end-user machines or embedded in PCFs/plugins do <strong>not</strong> communicate with external servers for license validation purposes.
                    They interact only with your Dataverse components for doing so.
                </Text>
            </CardSection>

            <CardSection title="Optional Publisher Telemetry">
                <Text>
                    Publishers may choose to enable telemetry that reports aggregate statistics — like the number of active users per product — to the Ianus Guard portal.
                    <br />
                    This is an <em>opt-in</em> feature controlled by the publisher, not enabled automatically.
                </Text>
            </CardSection>
        </div>
    );
});
